import React from "react";
import CaseDetailCard from "./caseDetailCard";

const AuditLogDetails = ({ caseDetails }) => {
    return (
        <div className="grid grid-cols-1 xl:grid-cols-2 md:grid-cols-2 gap-4 mt-4">
            {caseDetails?.createdDate && <CaseDetailCard
                label="created"
                user={caseDetails?.createdBy}
                date={caseDetails?.createdDate}
            />}
            {caseDetails?.modifiedDate && <CaseDetailCard
                label="modified"
                user={caseDetails?.modifiedBy}
                date={caseDetails?.modifiedDate}
            />}
        </div>
    );
};

export default AuditLogDetails;
